import { MatProgressBarModule } from "@angular/material/progress-bar";
import { DialogConfirmComponent } from "./shared/dialog-confirm/dialog-confirm.component";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { PathLocationStrategy, LocationStrategy } from "@angular/common";

import { ToastrModule } from "ngx-toastr";

import { AppRoutingModule } from "./routes/app-routing.module";
import { AppComponent } from "./app.component";
import { InterceptorService } from "./core/services/default/interceptor.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SpriteSvgComponent } from "./core/components/sprite-svg/sprite-svg.component";
import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";

import { SharedModule } from "src/app/shared/shared.module";
import { LoadingComponent } from "./core/components/loading/loading.component";
import { BreadcrumbVbModule } from "./shared/componentes/breadcrumb-vb/breadcrumb-vb.module";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { reducers } from "./store/auction.reducers";
import { environment } from "../environments/environment";
import { UtilsService } from "./utils/utils.service";
import { SortArrayService } from "./utils/sort-array.service";

registerLocaleData(localePt);

@NgModule({ declarations: [AppComponent, SpriteSvgComponent, LoadingComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [SharedModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatProgressBarModule,
        ToastrModule.forRoot(),
        BreadcrumbVbModule,
        StoreModule.forRoot({ stateAction: reducers }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        })], providers: [
        InterceptorService,
        UtilsService,
        SortArrayService,
        { provide: LOCALE_ID, useValue: "pt-BR" },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
